import { HsShaderDataType } from '../enums/shader-data-type.enum';
import { HsShaderObjectType } from '../enums/shader-object-type.enum';

/**
 * Handles s get matrix uniform.
 */
export function hsGetMatrixUniform(name: string, dataType: HsShaderDataType, objectType: HsShaderObjectType): string {
  if (objectType === HsShaderObjectType.single) {
    return `${HsShaderDataType[dataType]} ${name} = u_${name};`;
  }
  if (objectType === HsShaderObjectType.collection) {
    if (dataType === HsShaderDataType.mat2) {
      return `mat2 ${name};
      ${name}[0] = a_${name}0;
      ${name}[1] = a_${name}1;`;
    }
    if (dataType === HsShaderDataType.mat3) {
      return `mat3 ${name};
      ${name}[0] = a_${name}0;
      ${name}[1] = a_${name}1;
      ${name}[2] = a_${name}2;`;
    }
    if (dataType === HsShaderDataType.mat4) {
      return `mat4 ${name};
      ${name}[0] = a_${name}0;
      ${name}[1] = a_${name}1;
      ${name}[2] = a_${name}2;
      ${name}[3] = a_${name}3;`;
    }
    return `${HsShaderDataType[dataType]} ${name} = a_${name};`;
  }
  return '';
}
